import { config } from '../config';

const CURRENCY_DECIMALS = { JPY: 0, KRW: 0, VND: 0 };

export function slugify(value) {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function formatMinorAmount(amount, currency = 'USD') {
  if (amount == null) {
    return '—';
  }
  const decimals = CURRENCY_DECIMALS[currency] ?? 2;
  const divisor = 10 ** decimals;
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  }).format(Number(amount) / divisor);
}

export function formatMoney(value, currency = 'USD') {
  if (value == null || value === '') {
    return '—';
  }
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  }).format(Number(value));
}

export function mediaUrl(path, baseUrl) {
  if (!path) {
    return null;
  }
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const base = (baseUrl || '').replace(/\/$/, '');
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

export function formatStatus(status) {
  if (!status) {
    return '—';
  }
  return status
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export const SHOP_ROLES = ['admin', 'manager', 'auditor', 'order_processor'];

const SHOP_ROLE_LABELS = {
  admin: 'Administrator',
  manager: 'Manager',
  auditor: 'Auditor',
  order_processor: 'Order processor',
};

export function formatRole(role) {
  if (!role) {
    return '—';
  }
  return SHOP_ROLE_LABELS[role] ?? formatStatus(role);
}

export function storefrontHostnameForSlug(slug) {
  if (!slug) {
    return null;
  }
  return `${slug.trim().toLowerCase()}.${config.storefrontDomainSuffix}`;
}

export function storefrontUrlForShop(shop) {
  if (!shop) {
    return null;
  }
  if (shop.storefront_url) {
    return shop.storefront_url;
  }
  if (shop.storefront_hostname) {
    return `https://${shop.storefront_hostname}`;
  }
  if (shop.slug) {
    return `https://${storefrontHostnameForSlug(shop.slug)}`;
  }
  return null;
}

export const ORDER_STATUSES = [
  'PENDING',
  'APPROVED',
  'PACKED',
  'SHIPPED',
  'DELIVERED',
  'CANCELLED',
  'PENDING_RETURN',
  'RETURNED',
];

export const emptyAddress = {
  label: '',
  full_name: '',
  company: '',
  phone: '',
  email: '',
  line1: '',
  line2: '',
  city: '',
  state: '',
  postal_code: '',
  country_code: 'US',
  is_default_shipping: false,
  is_default_billing: false,
};
